<template>
  <div class="postcode-search">
    <p class="black">
      Enter your postcode to find 100% grass-fed beef and lamb from UK farms and butchers.
    </p>
    <div class="search">
      <input
        pattern="[A-Za-z]{1,2}[0-9Rr][0-9A-Za-z]? [0-9][ABD-HJLNP-UW-Zabd-hjlnp-uw-z]{2}"
        type="text"
        id="postcode"
        name="postcode"
        class="postcode-input mb-16"
        placeholder="Enter postcode"
        v-model="postcode"
        @keyup.enter="searchByPostcode"
      />
      <a @click="getUserLocation" class="link-red find-me">
        <i class="fad fa-location"></i>
      </a>
    </div>
    <button
      type="button"
      class="btn-green btn btn-fill"
      @click="searchByPostcode"
    >
      Show {{ locations }} locations
    </button>
  </div>
</template>

<script>
// import gmapsInit from "../../helpers/google-maps.js";
import postCodes from "../../helpers/postcodes.js";

export default {
  name: "PostcodeSearch",
  computed: {
    locations() {
      return null;
    }
  },
  data() {
    return {
      postcode: null
    };
  },
  async mounted() {
    // Use below for postcode autocomplete
    // const input = document.getElementById('postcode');
    // this.google = await gmapsInit();
    // new this.google.maps.places.SearchBox(input);
  },
  methods: {
    trackEvent(action, category) {
      this.$gtag.event(action, {
        event_category: category
      });
    },
    searchByPostcode() {
      this.trackEvent("search_postcode", "search");

      this.postcode = postCodes.sanitizePostCode(this.postcode);
      if (postCodes.isPostCodeValid(this.postcode)) {
        this.$router.push({
          path: "results",
          query: { postcode: this.postcode }
        });
      } else {
        alert("Please provide a valid UK Post code.");
      }
    },
    getUserLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          this.searchByLocation,
          this.getCurrentPositionError
        );
      } else {
        alert("Geolocation is not supported by this browser.");
      }
      return false;
    },
    searchByLocation(position) {
      this.trackEvent("search_my_location", "search");
      console.log(position);
      this.$router.push({
        path: "results",
        query: { lat: position.coords.latitude, lng: position.coords.longitude }
      });
    },
    getCurrentPositionError(positionError) {
      console.log(positionError);
      alert(positionError.message);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/global-styles/variables.scss";

.postcode-search {
  .search {
    position: relative;
    text-align: center;
    float: left;
    margin-right: $spacing-5;

    button {
      float: left;
    }
  }

  .find-me {
    padding: $spacing-3;
    position: absolute;
    right: $spacing-0;
    top: $spacing-0;
  }

  .postcode-input {
    padding-right: $spacing-7;
  }
}

a {
  cursor: pointer;
  padding: $spacing-3;
}
</style>
